export const ACTION_SHOW_LOCATION_EXPLANATION_DIALOG = 'ACTION_SHOW_LOCATION_EXPLANATION_DIALOG';
export const ACTION_HIDE_LOCATION_EXPLANATION_DIALOG = 'ACTION_HIDE_LOCATION_EXPLANATION_DIALOG';
